<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PageAlerts from "@/components/page-alerts";
import appConfig from "@/app.config";
import constants from "../../constants";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Report Card",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    PageAlerts,
  },
  data() {
    return {
      title: "Results",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Report Card",
          active: true,
        },
      ],
      data: {
        month: "",
        course: "",
        class: "",
        testResults: "",
        year: "",
      },
      months: [
        { value: "01", month: "January" },
        { value: "02", month: "February" },
        { value: "03", month: "March" },
        { value: "04", month: "April" },
        { value: "05", month: "May" },
        { value: "06", month: "June" },
        { value: "07", month: "July" },
        { value: "08", month: "August" },
        { value: "09", month: "September" },
        { value: "10", month: "October" },
        { value: "11", month: "November" },
        { value: "12", month: "December" },
      ],
      summitGrades: [],
      sysConstants: constants,
    };
  },
  watch: {},
  computed: {
    ...mapGetters("coursework", ["AllSets", "SaveStatus"]),
    ...mapGetters("classes", [
      "AllClasses",
      "AllClassStreams",
      "AllCourses",
      "CustomClasses",
    ]),
    ...mapGetters("marks", [
      "getYears",
      "getReportDetails",
      "getFechingReports",
      "getTestResult",
    ]),
    ...mapGetters("auth", ["getCurrentUser"]),
  },
  mounted() {},
  methods: {
    ...mapActions({
      FetchCourses: "classes/fetchCourses",
      FetchYears: "marks/fetchYear",
      FetchResults: "marks/fetchResults",
      FetchReportDetails: "marks/fetchReportDetails",
      FetchClasses: "classes/fetchClasses",
      FetchClassStreams: "classes/fetchClassStreams",
      FetchSets: "coursework/fetchSets",
      AddSet: "coursework/addSet",
      EditSet: "coursework/editSet",
      DeleteSets: "coursework/deleteSet",
      FetchStreams: "classes/fetchStreams",
      FetchCustomClasses: "classes/fetchCustomClasses",
    }),
    fetchClasses() {
      const selectedCourse = { course: this.data.course };
      this.FetchCustomClasses(selectedCourse);
    },
    submitFilter() {
      this.FetchReportDetails(this.data);
    },
    fetchTestResults() {
      this.FetchResults(this.data);
    },
  },
  created() {
    this.FetchYears();
    this.FetchClasses();
    this.FetchStreams();
    this.FetchSets();
    this.FetchCourses();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('report_cards')
        )
      "
    >
      <div class="row d-flex">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-xl-4 col-md-4">
                  <div class="product-detai-imgs">
                    <div class="product-img">
                      <img
                        src="../../../assets/images/report/default_template.png"
                        alt="Report Template"
                        class="img-fluid mx-auto d-block"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-xl-8 col-md-8">
                  <h5 class=""><b>Report filters</b></h5>
                  <hr />
                  <p class="text-muted my-5">
                    At the left is the report template that you are using.<br />
                    <b>please use the filters below to retrieve the reports</b>
                  </p>
                  <form class="mb-3" @submit.prevent="submitFilter()">
                    <div class="row">
                      <div class="form-group col-md-2">
                        <div class="form-group">
                          <label for=""
                            >Course <small class="text-danger">*</small></label
                          >
                          <select
                            required
                            class="form-control form-control-sm"
                            v-model="data.course"
                            name=""
                            id=""
                            @change="fetchClasses()"
                          >
                            <option value="" selected disabled
                              >Select Course</option
                            >
                            <option
                              v-for="(course, index) in AllCourses"
                              :key="index"
                              :value="course.id"
                            >
                              {{ course.name }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group col-md-2">
                        <div class="form-group">
                          <label for=""
                            >Level <small class="text-danger">*</small></label
                          >
                          <select
                            required
                            class="form-control form-control-sm"
                            v-model="data.class"
                            name=""
                            id=""
                          >
                            <option value="" selected disabled
                              >Select Level</option
                            >
                            <option
                              v-for="(classes, index) in CustomClasses"
                              :key="index"
                              :value="classes.id"
                            >
                              {{ classes.short }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group col-md-2">
                        <div class="form-group">
                          <label for=""
                            >Year <small class="text-danger">*</small></label
                          >
                          <select
                            class="form-control form-control-sm"
                            v-model="data.year"
                            name=""
                            id=""
                          >
                            <option value="" selected disabled
                              >Select Year</option
                            >
                            <option
                              v-for="(schyear, index) in getYears"
                              :value="schyear.year"
                              :key="index"
                            >
                              {{ schyear.year }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group col-md-2">
                        <div class="form-group">
                          <label for=""
                            >Month <small class="text-danger">*</small></label
                          >
                          <select
                            class="form-control form-control-sm"
                            v-model="data.month"
                            @change="fetchTestResults()"
                            name=""
                            id=""
                          >
                            <option value="" selected disabled
                              >Select Month</option
                            >
                            <option
                              v-for="(month, index) in months"
                              :value="month.value"
                              :key="index"
                            >
                              {{ month.month }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group col-md-2">
                        <div class="form-group">
                          <label for=""
                            >Test Results
                            <small class="text-danger">*</small></label
                          >
                          <select
                            class="form-control form-control-sm"
                            v-model="data.testResults"
                            name=""
                            id=""
                          >
                            <option value="" selected disabled
                              >Select Results</option
                            >
                            <option
                              v-for="(result, index) in getTestResult"
                              :value="result.date"
                              :key="index"
                            >
                              On {{ result.date }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-3 mt-3">
                        <button
                          type="submit"
                          size="sm"
                          disabled
                          class="btn btn-sm btn-outline-primary mt-2"
                          v-if="getFechingReports"
                        >
                          <b-spinner
                            variant="primary"
                            small
                            label="Fetching Data..."
                          ></b-spinner>
                          Fetching Data...
                        </button>
                        <button
                          v-else
                          type="submit"
                          size="sm"
                          class="btn btn-sm btn-outline-primary mt-2"
                        >
                          <i class="fa fa-check"></i>
                          Submit Filers
                        </button>
                      </div>
                    </div>
                  </form>
                  <div
                    class="m-2"
                    v-if="getReportDetails && getReportDetails.report_url"
                  >
                    <PageAlerts
                      title="Success"
                      primaryMsg="Report Generated successfully!. Please click on the button below to view or download the report."
                      alertType="success"
                    />
                    <router-link
                      to="/students/view_report"
                      role="button"
                      class="btn btn-sm btn-success"
                    >
                      <i class="fa fa-file"></i>
                      View Reports
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end card -->
        </div>
      </div>
    </div>
    <!-- <div class="breaker"></div> -->
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.bod {
  border: 1px solid gray;
}
.break {
  page-break-after: auto !important;
  page-break-before: always;
}
</style>
